import React, { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import styles from './dashboard.module.scss'
import PageSpinner from '@components/ui/PageSpinner/PageSpinner'
import { useUserRole } from '@store/selectors/auth'
// import useSocket from '@hooks/useSocket'
import cn from 'classnames'
import { EUserRoles } from '@enums/roles'
import { LoadSpinContext } from '@context/loadSpinContext'
// import { SocketContext } from '@context/socketContext'
import useHeader from '@hooks/useHeader'
import AdminHeader from '@components/Header/AdminHeader/AdminHeader'
import Sidebar from '@components/SideBar/Sidebar'

const DashboardLayout: React.FC = () => {
  // const header = useHeader()
  // const role = useUserRole()
  // const { socket, emit, usersStatus, updateRecall, updateTransmit } = useSocket()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  return (
    // <SocketContext.Provider
    //   value={{
    //     socket,
    //     emit,
    //     usersStatus,
    //     updateRecall,
    //     updateTransmit,
    //   }}
    // >
    <div className={styles.container}>
      <AdminHeader />
      <div
        className={cn(
          styles.body,
          styles.admin,
          // {
          // [styles.admin]: role === EUserRoles.BOSS,
          // [styles.manager]: role === EUserRoles.ACCOUNTANT,
          // [styles.admin]: role === EUserRoles.SUPER_ADMIN,
          // }
        )}
      >
        <LoadSpinContext.Provider value={{ setLoad: setIsLoading, isLoad: isLoading }}>
          <Suspense fallback={<PageSpinner />}>
            <Sidebar />
            <div className={styles.main}>
              <Outlet />
            </div>
          </Suspense>
        </LoadSpinContext.Provider>
      </div>
      {isLoading && <PageSpinner className={styles.loadSpin} />}
    </div>
    // </SocketContext.Provider>
  )
}

export default DashboardLayout
